import actionTypes from './actionTypes'

const initialState = {
  list: [],
  authorizeList: [] // 我的授权列表
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVELIST:
      return {...state, ...action.payload}
    case actionTypes.SAVEAUTHORIZELIST:
      return {...state, ...action.payload}
    default:
      return state
  }
}

export default reducer
